module.exports = __webpack_public_path__ + "static/flags/RW-53dbc9e3d3f27cfbcea21d211f83c58a.gif";